<script>
import PedalKnob from '../PedalKnob.vue';
import CcBadge from '../CcBadge.vue';

export default {
  components: { PedalKnob, CcBadge },
  props: {
    effect: {
      type: Object,
      required: true
    }
  }
}
</script>
<template>
  <div class="pedal-knobs">
    <CcBadge :effect="effect" param="min">
      <PedalKnob
        label="Min"
        tip="Minimum value of the zig zag wave."
        :value="effect.min"
        @update:value="v => effect.min = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="max">
      <PedalKnob
        label="Max"
        tip="Maximum value of the zig zag wave."
        :value="effect.max"
        @update:value="v => effect.max = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="skew">
      <PedalKnob
        label="Skew"
        tip="Position of the peak within the cycle. Negative values mean a fast attack and slow release; positive values mean a slow attack and fast release."
        mode="bipolar"
        :value="effect.skew ?? 0"
        @update:value="v => effect.skew = v"
        />
    </CcBadge>
  </div>
</template>
